import { EventEmitter } from "events"
import dispatcher from "../dispatcher"
import { IWorkflow, IEmployeeWorkFlow } from "../models"

class WorkflowStore extends EventEmitter {
	Loading: boolean = true
	AccountSetupWorkflow: IWorkflow = null
	ShowWorkflowDrawer: boolean = false
	Workflows: IEmployeeWorkFlow[]
	dispatcherIndex

	constructor() {
		super()
		this.setMaxListeners(0)
	}

	setLoading(value) {
		this.Loading = value
		this.emit("change")
	}

	getLoadingStatus() {
		return this.Loading
	}

	getWorkflows() {
		return this.Workflows
	}

	getAccountSetupWorkflow() {
		return this.AccountSetupWorkflow
	}

	getShowWorkflowDrawer() {
		return this.ShowWorkflowDrawer
	}

	setShowWorkflowDrawer(value) {
		this.ShowWorkflowDrawer = value
		this.emit("change")
	}

	updateAccountSetupWorkflow(workflow) {
		this.AccountSetupWorkflow = workflow
		this.emit("change")
	}

	updateWorkflows(workflows) {
		this.Workflows = workflows
		this.emit("change")
	}

	handleActions(action) {
		switch (action.type) {
			case "START_LOADING_WORKFLOW": {
				this.setLoading(action.value)
				break
			}
			case "RECEIVE_ACCOUNT_SETUP_WORKFLOW": {				
				this.updateAccountSetupWorkflow(action.workflow)
				break
			}
			case "RECEIVE_WORKFLOWS": {
				this.updateWorkflows(action.workflow)
				break
			}
		}
	}
}

const workflowStore = new WorkflowStore()
workflowStore.dispatcherIndex = dispatcher.register(workflowStore.handleActions.bind(workflowStore))

export default workflowStore
